import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private ws: PostmethodService) { }

  getMasters() {
    return this.ws.wsGet(environment.loginUrl + "/admin/master/masterRecords");
  }
}
